/**
 * File: useLoginFormController.ts
 * Path: apps/admin/src/modules/auth/hooks/useLoginFormController.ts
 * Description: Everything the login form needs: its fields and validation, the busy flag, the last
 * error, and the submit and Google sign-in actions.
 */

import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useAuthController } from "@/modules/auth/hooks/useAuthController";
import { loginSchema, type LoginFormValues } from "@/modules/auth/utils/loginSchema";

export const useLoginFormController = () => {
  const { login, loginWithGoogle, isBusy, error } = useAuthController();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormValues>({
    resolver: zodResolver(loginSchema),
    defaultValues: { email: "", password: "" },
  });

  const onSubmit = handleSubmit((data) => {
    if (!data.password) return;
    login({ email: data.email, password: data.password });
  });

  return {
    register,
    onSubmit,
    errors,
    isBusy,
    error,
    loginWithGoogle: () => loginWithGoogle(),
  };
};
